export enum EGovernanceTab {
	WORKFLOW = 'workflow',
	AUDIT_LOG = 'audit-log',
}

export enum EWorkflowStatus {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected',
}

export const WorkflowStatusMap: Record<EWorkflowStatus, string> = {
	[EWorkflowStatus.PENDING]: 'Oczekuje',
	[EWorkflowStatus.APPROVED]: 'Zatwierdzony',
	[EWorkflowStatus.REJECTED]: 'Odrzucony',
}

export const WorkflowStatusTagType: Record<EWorkflowStatus, TagType> = {
	[EWorkflowStatus.PENDING]: 'default',
	[EWorkflowStatus.APPROVED]: 'success',
	[EWorkflowStatus.REJECTED]: 'error',
}

export enum EAuditLogType {
	CAMPAIGN = 'campaign',
	DISCOUNT_CODE = 'discount_code',
}

export const AuditLogTypeMap: Record<EAuditLogType, string> = {
	[EAuditLogType.CAMPAIGN]: 'Kampania',
	[EAuditLogType.DISCOUNT_CODE]: 'Kod rabatowy',
}

export const AuditLogTypeTagType: Record<EAuditLogType, TagType> = {
	[EAuditLogType.CAMPAIGN]: 'primary',
	[EAuditLogType.DISCOUNT_CODE]: 'default',
}

const CAMPAIGN_TYPE = 'Kampania rabatowa'

/* eslint-disable sonarjs/no-duplicate-string -- dane mockowe */
export const MOCK_WORKFLOW_REQUESTS: IWorkflowRequestModel[] = [
	{
		id: 1,
		type: CAMPAIGN_TYPE,
		name: 'Influencer Q1 2026',
		requester: 'Adam Kowalski',
		requestDate: '10.04.2025, 10:06',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 2,
		type: CAMPAIGN_TYPE,
		name: 'WELCOME10',
		requester: 'Kinga Kowalska',
		requestDate: '25.01.2026, 8:15',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 3,
		type: CAMPAIGN_TYPE,
		name: 'Influencer Q1 2026',
		requester: 'Maria Nowak',
		requestDate: '22.12.2025, 12:00',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 4,
		type: CAMPAIGN_TYPE,
		name: 'NeoNet12',
		requester: 'Marta Zielińska',
		requestDate: '27.11.2025, 10:15',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 5,
		type: CAMPAIGN_TYPE,
		name: 'Influencer Q1 2026',
		requester: 'Jakub Panek',
		requestDate: '11.05.2025, 19:20',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 6,
		type: CAMPAIGN_TYPE,
		name: 'BiegWarszawski2025',
		requester: 'Karol Włodek',
		requestDate: '25.01.2026, 10:15',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 7,
		type: CAMPAIGN_TYPE,
		name: 'Influencer Q1 2026',
		requester: 'Marta Zielińska',
		requestDate: '27.11.2025, 10:15',
		status: EWorkflowStatus.PENDING,
	},
	{
		id: 8,
		type: CAMPAIGN_TYPE,
		name: 'WELCOME10',
		requester: 'Katarzyna Zajdel',
		requestDate: '11.05.2025, 19:20',
		status: EWorkflowStatus.PENDING,
	},
]

export const MOCK_AUDIT_LOG: IAuditLogEntryModel[] = [
	{
		id: 1,
		date: '25.01.2026, 10:15',
		user: 'Anna Kowalska',
		type: EAuditLogType.CAMPAIGN,
		object: 'Bieg Krakowski 2026',
		action: 'Aktywacja kampanii',
		changes: 'Status: szkic → aktywna',
		reason: 'Zatwierdzenie przez Marketing Lead',
	},
	{
		id: 2,
		date: '12.01.2026, 09:30',
		user: 'Marta Zielińska',
		type: EAuditLogType.DISCOUNT_CODE,
		object: 'WELCOME10',
		action: 'Utworzenie kodu',
		changes: 'Nowy kod rabatowy',
		reason: 'Kod powitalny dla nowych klientów',
	},
	{
		id: 3,
		date: '10.01.2026, 14:45',
		user: 'Jakub Panek',
		type: EAuditLogType.CAMPAIGN,
		object: 'NeoNet Winter 2026',
		action: 'Zmiana statusu',
		changes: 'Status: aktywna → wstrzymana',
		reason: 'Przekroczenie budżetu kampanii',
	},
	{
		id: 4,
		date: '08.01.2026, 11:20',
		user: 'Kinga Kowalska',
		type: EAuditLogType.DISCOUNT_CODE,
		object: 'NEWYEAR2026',
		action: 'Edycja limitu',
		changes: 'Limit: 500 → 1000',
		reason: 'Zwiększenie puli na życzenie klienta',
	},
	{
		id: 5,
		date: '05.01.2026, 08:00',
		user: 'Anna Kowalska',
		type: EAuditLogType.CAMPAIGN,
		object: 'Influencer Q1 2026',
		action: 'Utworzenie kampanii',
		changes: 'Nowa kampania',
		reason: 'Planowana akcja Q1 z influencerami',
	},
	{
		id: 6,
		date: '03.01.2026, 16:30',
		user: 'Karol Włodek',
		type: EAuditLogType.CAMPAIGN,
		object: 'FoodPack20',
		action: 'Dezaktywacja kampanii',
		changes: 'Status: aktywna → zakończona',
		reason: 'Koniec okresu promocyjnego',
	},
]
/* eslint-enable sonarjs/no-duplicate-string */
